import { GraficaEstadisticaVehiculoComponent } from './grafica-estadistica-vehiculo/grafica-estadistica-vehiculo.component';
import { AuthService } from './../../../../../auth/auth.service';
import { posiciones, reportePosiciones } from './../../../../../../_entities/coordenadas/ReportePosiciones';
import { finalize } from 'rxjs/operators';
import { MapaService } from './../../../../services/mapa.service';
import { DatePipe } from '@angular/common';
import { VehiculosService } from './../../../../services/vehiculos.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig } from '@angular/material';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { GaleriaVideoService } from './../../../../services/galeria-video.service';
import { Autos } from './../../../../../../_entities/autos/Autos';
import { ToastrService } from 'ngx-toastr';
import { ALERTAS, IGNICIONES } from './../../../../../../_entities/estados';
import { ReproduccionComponent } from '../reproduccion/reproduccion.component';
import { environment } from './../../../../../../../environments/environment';

@Component({
	selector: 'kt-historico-posiciones-vehiculo',
	templateUrl: './historico-posiciones-vehiculo.component.html',
	styleUrls: ['./historico-posiciones-vehiculo.component.scss']
})
export class HistoricoPosicionesVehiculoComponent implements OnInit {
	@ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
	@ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent;

	loadingVisible = false;
	public graficar: reportePosiciones;
	public reportePos: posiciones[] = [];
	
	public usuario;
	public idCliente;
	public HWUser;
	public idVehiculo;
	public descripcion;
	public idUsuario;

	public fechaInicio;
	public fechaFin;

	public showFilterRow: boolean;
	public showTable: boolean = false;

	public datosReporte = [];
	isDisable: boolean = true;

	public alDia = false;

	public botonGraficasDisabled: boolean = true;

	constructor(private vehiculosService: VehiculosService,
		private authService: AuthService,
		private datepipe: DatePipe,
		private toastService: ToastrService,
		private mapaService: MapaService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<HistoricoPosicionesVehiculoComponent>) {
		this.showFilterRow = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		this.usuario = this.authService.getUser();
		this.HWUser = this.authService.getHWUser();

		if (JSON.parse(sessionStorage.getItem('historico'))) {
			this.botonGraficasDisabled = false;
			const datosReporte = JSON.parse(sessionStorage.getItem('historico'));
			this.descripcion = JSON.parse(sessionStorage.getItem('data'));


			this.reportePos = datosReporte.posiciones;
			this.graficar = datosReporte;

			this.idVehiculo = this.descripcion.id;
			this.idCliente = this.descripcion.idCliente;

			this.reportePos.forEach(reporte => {
				let link = `${environment.EXTERNAL_MAP}/ubicar?lat=${reporte.lat}&lng=${reporte.lng}`

				this.datosReporte.push({
					'Ubicacion': {
						f: '=HYPERLINK("' + link + '","Ubicar")',
						v: link
					},
					'Fecha': reporte.fecha,
					'Placa': reporte.placas,
					'Ignición': reporte.ignicion,
					'Estado': reporte.estado,
					'Velocidad': (reporte.velocidad + ' km/h'),
					'Latitud': reporte.lat,
					'Longitud': reporte.lng
				});
			});

			if (this.datosReporte.length > 0) {
				this.isDisable = false;
				this.showTable = true;
			}

		} else {
			this.descripcion = this.data;
			this.idVehiculo = this.data.id;
			this.idCliente = this.descripcion.idCliente;
		}


	}

	reportePosicion(fechaInicio, fechaFin) {
		if (this.validationGroup.instance.validate().isValid || this.alDia) {
			this.loadingVisible = true;
			const FECHA_INICIO = this.datepipe.transform(fechaInicio, 'yyyy-MM-dd HH:mm:ss');
			const FECHA_FINAL = this.datepipe.transform(fechaFin, 'yyyy-MM-dd HH:mm:ss');

			this.mapaService.tipoProducto = 'vehiculo';
			this.mapaService.historicoFechas = [FECHA_INICIO, FECHA_FINAL];

			if (this.descripcion.idCliente != 39) {
				this.vehiculosService.getReporteHistorico(this.idVehiculo, FECHA_INICIO, FECHA_FINAL).pipe(
					finalize(
						() => {
							this.botonGraficasDisabled = false;
							this.loadingVisible = false;
							this.alDia = false;
							this.cerrarPopup();
						}
					)
				).subscribe(
					(reporte: reportePosiciones) => {
						if (reporte.posiciones.length > 0) {
							reporte.posiciones.map(dato => {
								let ignicion = IGNICIONES.find(ignicion => ignicion.id === dato.ignicion);
								dato.ignicion = ignicion.nombre;

								let estado = ALERTAS.find(alerta => alerta.id == dato.estado);
								dato.estado = estado.nombre;
								dato.icono = estado.icono;

								dato.fecha = this.datepipe.transform(dato.fecha, 'dd/MM/yyyy hh:mm:ss a');
							});

							sessionStorage.setItem('historico', JSON.stringify(reporte));
							sessionStorage.setItem('data', JSON.stringify(this.descripcion));

							this.mapaService.posicionesReporte = reporte.posiciones;
							this.mapaService.datosGenerales = this.descripcion;
							this.mapaService.pintarMarcadoresHistorico();

							/**Validacion para cambiar el estilo de los botones en el mapa */
							this.mapaService.estadoHistorico = true;
							this.mapaService.validarEstadoHistorico();
							this.mapaService.abrirPopupRecorrido();


						} else {
							this.toastService.info('No existen datos disponibles')
						}

					}
				);
			}
			else {
				this.reportePosicionDVR(FECHA_INICIO, FECHA_FINAL);
			}

		} else {
			this.toastService.warning('Existen campos requerídos vacíos')

		}
	}

	reportePosicionDVR(FECHA_INICIO, FECHA_FINAL) {
		const pageNum = '-1';
		const pageCount = -1;

		this.vehiculosService.obtenerAutosCamara( pageNum, pageCount, FECHA_INICIO, FECHA_FINAL, this.data.imeiFk).pipe(
			finalize(
				() => {
					this.botonGraficasDisabled = false;
					this.loadingVisible = false;
					this.alDia = false;
					this.cerrarPopup();
				}
			)
		).subscribe(
			(response) => {
				if (response.data != null) {
					let reporteHistorico = [];
					response.data.forEach((dato, index) => {
						let ignicion = 0;
						let estado = 0;

						if (Number(dato.speed) > 5) {
							ignicion = 1;
							estado = 1;
						}

						let reporte: posiciones = {
							fecha: dato.dtu,
							ignicion: ignicion,
							estado: estado,
							velocidad: Math.round(dato.speed),
							lat: Number(dato.latitude),
							lng: Number(dato.longitude),
							vehiculo: response.vehiculo.vehiculo,
							id: index,
							placas: response.vehiculo.placas,
							economico: response.vehiculo.economico,
							marca: response.vehiculo.marca,
							modelo: response.vehiculo.modelo,
							icono: '',
							fechaInicial: '',
							fechaFinal: '',
						}

						reporteHistorico.push(reporte);
					});

					reporteHistorico.map(dato => {
						let ignicion = IGNICIONES.find(ignicion => ignicion.id === dato.ignicion);
						dato.ignicion = ignicion.nombre;

						let estado = ALERTAS.find(alerta => alerta.id == dato.estado);
						dato.estado = estado.nombre;
						dato.icono = estado.icono;
					})

					const reportePosiciones: reportePosiciones = {
						totalDistancia: response.distanciaTotal,
						posiciones: reporteHistorico,
					}

					sessionStorage.setItem('historico', JSON.stringify(reportePosiciones));
					sessionStorage.setItem('data', JSON.stringify(response.vehiculo));

					this.mapaService.posicionesReporte = reporteHistorico;
					this.mapaService.datosGenerales = response.vehiculo;
					this.mapaService.pintarMarcadoresHistorico();
					const botonesRecorrido = document.getElementById('botonesRecorrido');
					//botonesRecorrido.style.display = 'block';

					/**Validacion para cambiar el estilo de los botones en el mapa */
					this.mapaService.estadoHistorico = true;
					this.mapaService.validarEstadoHistorico();
					this.mapaService.abrirPopupRecorrido();
				} else {
					this.toastService.info('No existen datos disponibles')
				}
			}
		);

	}

	reporteAlDia() {
		this.alDia = true;
		let fechaInicial = new Date().toString();
		let fechaFinal = new Date().toString();

		fechaInicial = this.datepipe.transform(fechaInicial, 'yyyy-MM-dd 00:00:00');
		fechaFinal = this.datepipe.transform(fechaFinal, 'yyyy-MM-dd HH:mm:ss');

		this.reportePosicion(fechaInicial, fechaFinal);

	}


	clearFilter() {
		this.dataGrid.instance.clearFilter();
	}


	public ubicarPuntoHistorico(data) {
		this.mapaService.ubicarPuntoHistorico(data);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


	/**Ver Graficas */
	verGraficas() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "54%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.graficar;
		this.dialog.open(GraficaEstadisticaVehiculoComponent, dialogConfig);
	}

	reproducciones() {
		this.cerrarPopup();
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "54%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.descripcion
		this.dialog.open(ReproduccionComponent, dialogConfig);
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}


}
